<template>
    <div class="rating-form-grade-input" role="group">
        <b-alert show variant="danger" v-if="hasError">
            {{$t('rating.the_entered_value_must_not_be_higher_than', {max: itemIn.max})}}
        </b-alert>

        <b-form-input class="form-control rating-value"
                      v-model="ratingValue"
                      type="text"
                      :disabled="isStudent"
                      :max="itemIn.max"
                      :placeholder="$t('rating.max_points', {max: itemIn.max})"
                      @blur="update">
        </b-form-input>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-rating-answer-component',
        props: ['itemIn', 'projectId', 'userIn', 'ratingFormId'],
        data() {
            return {
                isStudent: this.$authUser.isStudent(),
                ratingValue: null,
                hasError: false,
            }
        },

        mounted() {
            if(this.userIn !== undefined && this.itemIn.answers.length) {
                for(let i = 0; i < this.itemIn.answers.length; i++)
                {
                    if(this.itemIn.answers[i].user_id === this.userIn.id && this.itemIn.answers[i].rating_form_id === this.ratingFormId)
                    {
                        this.ratingValue = this.itemIn.answers[i].open_answer;
                    }
                }
            } else {
                for(let i = 0; i < this.itemIn.answers.length; i++)
                {
                    if(this.itemIn.answers[i].rating_form_id === this.ratingFormId)
                    {
                        this.ratingValue = this.itemIn.answers[i].open_answer;
                    }
                }
            }
        },

        methods: {
            update(field) {
                let rating = field.target.value

                if(!(/^[0-9,.]*$/.test(rating))) {
                    this.ratingValue = null;
                    this.hasError = true;
                    return;
                }

                if(rating.indexOf(',') !== -1){
                    rating = rating.replace(',', '.');
                }

                this.hasError = parseFloat(rating) > parseFloat(this.itemIn.max);

                if(this.hasError === false){
                    this.ratingValue = parseFloat(rating);
                    this.$emit('updateOpenAnswer', this.ratingValue);
                }
            },
        },

        watch: {
            ratingValue: function(newValue){
                this.ratingValue = isNaN(newValue) ? null : newValue;
            }
        }
    }
</script>

<style scoped lang="scss">
    .rating-form-grade-input {
        margin-left: $grid-gutter-width;

        input {
            border: 1px solid $border-color;
            max-width: 400px;
        }
    }

    input.rating-value::-webkit-outer-spin-button,
    input.rating-value::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input.rating-value[type=number] {
        -moz-appearance: textfield;
    }
</style>
